import { createPlatformEnvironment, EnvNames } from '@pinnakl/core/environment';

export const environment = createPlatformEnvironment(EnvNames.dev);
